import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignApplication = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "signApplication",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17703",
		"data-name": "Group 17703",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13097",
				"data-name": "Path 13097",
				d: "M5.95,13h6.9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13098",
				"data-name": "Path 13098",
				d: "M6,16H9.89",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13099",
				"data-name": "Path 13099",
				d: "M9.893,21H4.97A1.985,1.985,0,0,1,3,19V5A1.985,1.985,0,0,1,4.97,3H15.03A1.985,1.985,0,0,1,17,5v6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13100",
				"data-name": "Path 13100",
				d: "M19.293,12.707,13,19v2h2l6.293-6.293a1,1,0,0,0,0-1.414l-.586-.586a1,1,0,0,0-1.414,0Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13108",
				"data-name": "Path 13108",
				d: "M16.316,17.043s1.316-.632,1.316-1.579V14.358l-.96-.345a1.049,1.049,0,0,0-.713,0L15,14.358v1.106C15,16.412,16.316,17.043,16.316,17.043Z",
				transform: "translate(-9 -7.95)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13102",
		"data-name": "Path 13102",
		d: "M0,0H24V24H0Z",
		fill: "none",
		fillRule: "evenodd"
	})]
});
export default SvgSignApplication;
